import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { GeneralResponse } from 'src/app/shared/shared-data-models';
import { environment } from 'src/environments/environment';
import { UserMenuItemsOutputDto } from '../../data-models/user-permission.data.models';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionDataService {

  private controllerUrl: string = `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/UserPermissions/`;
  constructor(
      private baseApi: BaseApiService<any>,
  ) { }

  GetUserMenu(): Observable<GeneralResponse<UserMenuItemsOutputDto[]>> {
    return this.baseApi.Get(`${this.controllerUrl}UserMenu`);
  }
}
